module.exports = __webpack_public_path__ + "files/317e4e5698947bd7dc75e3a20defd1c9.png";